import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetBrands = createAsyncThunk(
  "brands/GetCategory",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(endPoint.GETBRANDS);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetBrandsSlice = createSlice({
  name: "Brands",
  initialState: {
    Brands: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetBrands.fulfilled, (state, action) => {
        state.Brands = action.payload;
      })
      .addCase(GetBrands.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetBrandsSlice.reducer;
